import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import adminSelectors from 'src/redux/selectors/adminSelectors';

const PrivateRoute = ({ privateElement }) => {
  const admin = useSelector(adminSelectors.admin);

  if (!admin) {
    return <Navigate to='/' />
  }

  return privateElement;
}

export default PrivateRoute;